import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import ButtonIcon from './button-icon';

const NavigationMobile = ({
	data,
	showMobileMenu,
	announcementsData,
}) => (
	<div className="navigation-mobile__background" role="presentation" onClick={() => showMobileMenu()}>
		<div className="navigation-mobile__container" role="presentation" onClick={e => e.stopPropagation()}>
			<div className="flex-row justify-space-between align-items-flex-start">
				<h3>Menu</h3>
				<ButtonIcon
					icon="xmark"
					onClick={() => showMobileMenu()}
					classes="navigation-mobile__close"
				/>
			</div>
			<ul className="navigation-mobile">
				{data ? (
					data.map((page, index) => (
						// eslint-disable-next-line react/no-array-index-key
						<li key={index}>
							<Link to={page.url} onClick={() => showMobileMenu()}>{page.name}</Link>
							{page.name === 'Latest News' && announcementsData?.length > 0 && (
								<div className="navigation-mobile__badge" />
							)}
						</li>
				))) : null}
			</ul>
		</div>
	</div>
);

export default NavigationMobile;

NavigationMobile.propTypes = {
	data: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		url: PropTypes.string,
	})).isRequired,
	showMobileMenu: PropTypes.func.isRequired,
	announcementsData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
